import script from "./PluginDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PluginDetails.vue?vue&type=script&setup=true&lang=js"

import "./PluginDetails.vue?vue&type=style&index=0&id=2a87b08b&scoped=true&lang=css"
import "./PluginDetails.vue?vue&type=style&index=1&id=2a87b08b&scoped=true&lang=css"
import "./PluginDetails.vue?vue&type=style&index=2&id=2a87b08b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a87b08b"]])

export default __exports__